/*eslint no-unsafe-optional-chaining: 0*/

import { USER_ID } from './constants';

export const getCsrfToken = () => {
  const csrfToken = document.querySelector('meta[name=csrf-token]')?.getAttribute('content');
  return csrfToken;
};

// These functions below should really not exist, we should be getting the userId from the CurrentUserContext instead.
export const getUserId = () => {
  const userId = localStorage.getItem(USER_ID);
  return userId;
};

export const clearUserCredentials = () => {
  localStorage.removeItem(USER_ID);
};

export const persistUserCredentials = (userId) => {
  localStorage.setItem(USER_ID, userId);
};
